// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__5IcEp","verifiedBlue":"verified-badge_verifiedBlue__Hse47","verifiedGovernment":"verified-badge_verifiedGovernment__WVN65"};